<template>
  <div class>
    <drawer :title="addEditTitle" :dialogShow="addEditShow" @handleChange="handleChangeDrawer">
      <div slot="body">
        <div class="totals-box pl24 mt20">
          <div class="flex-row mb30">
            <div class="itemName">卡项名称</div>
            <div class="itemNum">{{ shopInfo.cardName }}</div>
          </div>
          <div class="flex-row mb30">
            <div class="itemName">卡项类型</div>
            <div class="itemNum">{{ shopInfo.cardTypeCn }}</div>
          </div>
          <div class="flex-row mb30">
            <div class="itemName">开卡门店</div>
            <div class="itemNum">{{ shopInfo.shopName }}</div>
          </div>
          <div class="flex-row mb30">
            <div class="itemName">有效次数</div>
            <div class="itemNum moneys">{{shopInfo.originNum}}次</div>
          </div>
          <div class="flex-row mb30">
            <div class="itemName">剩余次数</div>
            <div class="itemNum moneys">{{shopInfo.leftCount}}次</div>
          </div>
          <div class="flex-row mb30">
            <div class="itemName">开卡日期</div>
            <div class="itemNum">{{formatDay(shopInfo.oxCtime)}}</div>
          </div>
          <div class="flex-row mb30">
            <div class="itemName">失效日期</div>
            <div class="itemNum">{{ shopInfo.validDay == -1 ? '永久有效' : formatDay(shopInfo.validEndTime)}}</div>
          </div>
          <div class="flex-row mb30" v-if="detailFlag">
            <div class="itemName"></div>
            <p class="jishi cur" @click="orderDetail">查看详情</p>
          </div>
          <!-- <div class="flex-row mb30">
            <div class="itemName">卡项名称</div>
            <div class="itemNum">{{ shopInfo.cardName }}</div>
          </div> -->
          <!-- <div class="flex-row mb30">
            <div class="itemName">套餐卡名称</div>
            <div class="itemNum">{{ shopInfo.cardName }}</div>
          </div> -->
        </div>
        <p class="order-title-boxs"><span class="blueBlock"></span><i>套餐明细</i></p>
        <div class="plr24">
          <el-table :data="groupList" header-cell-class-name="table_header_bgcolor">
            <el-table-column prop="itemName" label="产品" min-width="200px"></el-table-column>
            <el-table-column prop="itemPrice" label="价格" width="120px">
              <template slot-scope="scope">¥ {{ scope.row.itemPrice }}</template>
            </el-table-column>
            <el-table-column prop="orginNum" label="有效次数" width="120px"></el-table-column>
            <el-table-column prop="num" label="剩余次数" width="120px">
              <template slot-scope="scope">{{ scope.row.orginNum-scope.row.useNum }}</template>
            </el-table-column>
          </el-table>
        </div>
        <p class="order-title-boxs"><span class="blueBlock"></span><i>划卡记录</i></p>
        <div class="plr24">
          <el-table :data="detailList" header-cell-class-name="table_header_bgcolor">
            <el-table-column prop="shopName" label="消费门店" min-width="200px"></el-table-column>
            <el-table-column prop="tradeDate" label="消费时间" width="170px">
              <template slot-scope="scope">{{ formatDate(scope.row.tradeDate) }}</template>
            </el-table-column>
            <el-table-column prop="tradeNum" label="消费次数"></el-table-column>
          </el-table>
        </div>
      </div>
    </drawer>
    <Dialog
      title="卡项消费明细"
      :hide="dialogVisible"
      @handleClick="changeClose"
      class="dialog-staff-box"
    >
      <div slot="header">卡项消费明细</div>
      <div slot="body">
        <div class="boxs" style="padding: 10px;">
          <div v-for="(item,index) in detailList" :key="index" class="box">
            <p :class="item.show?'active':''" v-if="item.status == 'enable'">{{ item.staffName }}</p>
          </div>
          <el-table :data="detailList" border>
            <el-table-column prop="shopIdCn" label="消费门店" min-width="200px"></el-table-column>
            <el-table-column prop="tradeNum" label="划卡次数"></el-table-column>
            <el-table-column prop="tradeDate" label="划卡时间" width="150px">
              <template slot-scope="scope">{{ formatDate(scope.row.tradeDate) }}</template>
            </el-table-column>
          </el-table>
          <!-- <el-table :data="detailList" border>
            <el-table-column prop="shopIdCn" label="消费门店" min-width="200px"></el-table-column>
            <el-table-column prop="tradeNum" label="划卡次数"></el-table-column>
            <el-table-column prop="tradeDate" label="划卡时间" width="150px">
              <template slot-scope="scope">{{ formatDate(scope.row.tradeDate) }}</template>
            </el-table-column>
          </el-table>-->
        </div>
      </div>
      <div slot="footer">
        <div class="flex flex-row">
          <div class="mt10">
            <el-button type="primary" plain @click="changeClose">返回</el-button>
          </div>
        </div>
      </div>
    </Dialog>
    <edit-order ref="editOrder"></edit-order>
  </div>
</template>

<script>
import minxin from "../../assets/javascript/minxin.js";
import drawer from "../../components/common/drawer";
import Dialog from "../../components/common/dialog";
import editOrder from "../orderInfo/edit.vue";
export default {
  mixins: [minxin],
  components: { drawer, Dialog ,editOrder},
  data() {
    return {
      addEditTitle: "卡项消费明细",
      addEditShow: false,
      form: {
        mobile: "",
        gender: "male"
      },
      columns: [],
      list: [],
      detailList: [],
      groupList: [],//套餐明细
      cardOldName: "",
      showPicker: false,
      dialogVisible: false,
      shopInfo: {},
      detailFlag: false
    };
  },
  created() {
    this.editInit();
  },
  methods: {
    editInit() {
      this.$on("set", function(org) {
        Object.assign(this.$data, this.$options.data());
        console.log(org,'org');
        this.$api
          .get(this.$url.member.listConsumeById, {
            id: org.id
          })
          .then(res => {
            if (res) {
              this.detailList = res;
            }
          });

          this.$api
          .get(this.$url.member.listCardRight, {
            id: org.id
          })
          .then(res => {
            if (res) {
              this.groupList = res;
            }
          });

        if (localStorage.getItem("shopIds") == org.originShopId) this.detailFlag = true;
        this.shopInfo = org;
        this.addEditShow = true;
      });
    },
    back() {
      //   this.$router.push("/collectMoney");
      this.addEditShow = false;
    },
    handleDetail(row) {
      this.$api
        .get(this.$url.member.listConsumeById, {
          id: row.id
        })
        .then(res => {
          if (res) {
            this.detailList = res;
          }
        })
        .catch(error => {});
      this.dialogVisible = true;
    },
    changeClose() {
      this.dialogVisible = false;
    },
    handleChangeDrawer() {
      this.addEditShow = false;
      this.$emit("change", false);
    },
    onSubmit(values) {
      this.addEditShow = false;
    },
    orderDetail () {
        this.$refs["editOrder"].$emit("set", this.shopInfo.orderId);
    },
  }
};
</script>
<style scoped lang="less">
@import "../../assets/css/edit.less";
.pay-mains {
 
}
</style>